export enum LegStatusEnum {
    Normal = "Normal", 
    Closed = "Closed",
    Canceled = "Canceled",
    Suspended = "Suspended",
    ClosedPending = "ClosedPending"
}
